<template>
    <div class="mt-4" v-if="products && products.length > 0">
        <div class="md:flex md:items-center md:justify-between">
            <h2 class="text-2xl font-bold tracking-tight text-gray-900">{{ title }}</h2>
            <ShopLink class="hidden md:block" v-if="link" :href="link">{{ linkText }}</ShopLink>
        </div>

        <div class="mt-6 grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
            <Item v-for="product in products" :product="product"/>
        </div>

        <div class="my-8 md:hidden text-center">
            <ShopLink class="!text-lg" v-if="link" :href="link">{{ linkText }}</ShopLink>
        </div>
    </div>
</template>

<script setup>
import Item from "@/Pages/Product/Partials/Item.vue";
import ShopLink from "@/Components/ShopLink.vue";

defineProps({
    title: String,
    link: String,
    products: Array,
    linkText: {
        type: String,
        default: "View all",
    }
});
</script>
